import * as helpers from '../../js/helpers';

export default function managePageImage() {
    const header = document.querySelector('.site-header');

    if (header === null) {
        return;
    }

    const pageImage = header.querySelector('.page-image');
    const headerBar = header.querySelector('.header-bar');

    if (pageImage !== null) {
        helpers.addClass(header, '-has-image');
        helpers.addClass(headerBar, '-absolute');
    }
}
